export const styles = {
  buttonWrapper: (theme) => ({
    display: 'flex',
    justifyContent: 'flex-start',
    [theme.breakpoints.down('sm')]: {
      mt: 8,
      justifyContent: 'center',
    },
    zIndex: 2,
  }),
};
